export default __webpack_public_path__ + "e5da544f64525ddfa538c6589f6b1d5c.png";